import React from 'react';

const Alert = ({ children, variant = 'error' }) => {
  return (
    children && (
      <div
        className={`
				${
          variant === 'error'
            ? 'border border-solid border-[#FF0000] bg-black text-white'
            : ''
        }
				${
          variant === 'help'
            ? 'bg-[#F7F7FF] dark:border dark:border-solid dark:border-[#4B4BFF] dark:bg-black'
            : ''
        }
				${
          variant === 'success'
            ? 'bg-[#F5FFF5] dark:border dark:border-solid dark:border-[#008A0D] dark:bg-black'
            : ''
        }
				${
          variant === 'warning'
            ? 'bg-[#F5F5F5] dark:border dark:border-solid dark:border-[#D47307] dark:bg-black'
            : ''
        }
				 flex items-start rounded-md p-3
			`}>
        <div className="min-w-5">
          {variant === 'error' && <i className="fas fa-times" />}
          {variant === 'help' && <i className="fas fa-question" />}
          {variant === 'success' && <i className="fas fa-check" />}
          {variant === 'warning' && (
            <i className="fas fa-exclamation-triangle" />
          )}
        </div>
        <div>
          <h1 size="small" additionalClasses="ml-3 text-white">
            {children}
          </h1>
        </div>
      </div>
    )
  );
};

export default Alert;
